import {
  CoveragePlanCardUrl,
  CoveragePlanType
} from '@cms-max/medicare-api-sdk'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

type Args = {
  type: CoveragePlanType
  urls: Array<CoveragePlanCardUrl>
  language: string
}
export function usePlanCardLink (
  args: Args
): { text: string; url: string } | null {
  const { language, type, urls } = args
  const { t } = useTranslation('accountHome', {
    keyPrefix: 'currentPlans.links'
  })

  return useMemo(() => {
    const url = urls.find((url) => url.language === language)?.url
    if (!url) return null

    let text = ''
    switch (type) {
      case CoveragePlanType.Ma:
      case CoveragePlanType.Mapd:
      case CoveragePlanType.Pdp:
        text = t('costAndCoverage')
        break
      case CoveragePlanType.OtherInsurance:
      case CoveragePlanType.Employer:
      case CoveragePlanType.PrimaryInsurance:
        text = t('other')
        break
      default:
        // OM, PBID
        text = t('coverage')
        break
    }

    return {
      text,
      url
    }
  }, [urls, language, type, t])
}
